interface ToolRunConfirmationProps {
  checked: boolean;
  onCheckedChange: (value: boolean) => void;
  warningText: string;
}

export default function ToolRunConfirmation({
  checked,
  onCheckedChange,
  warningText,
}: ToolRunConfirmationProps) {
  return (
    <div className="mt-5 rounded-lg border border-amber-200 bg-amber-50 p-4">
      <p className="text-sm text-amber-900">{warningText}</p>
      <label className="mt-3 inline-flex items-center gap-2 text-sm font-medium text-amber-900 cursor-pointer">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onCheckedChange(e.target.checked)}
          className="w-4 h-4 rounded border-amber-300 text-orange-600 focus:ring-orange-500"
        />
        I understand
      </label>
    </div>
  );
}
